export enum ComplianceSource {
  NHSTemplate = 'NHSTemplate',
  NHSAskHeidi = 'NHSAskHeidi',
}

export enum ComplianceStatus {
  Warning = 'Warning',
  Blocked = 'Blocked',
}

/**
 * Props for Ask Heidi NHS compliance events.
 */
export type NHSAskHeidiComplianceProps = {
  source: ComplianceSource.NHSAskHeidi;
  status: ComplianceStatus;
  /** Character length of the noncompliant_input echoed by the compliance check */
  compliance_output_length?: number;
  /** Character length of the rejected AI command text */
  ai_command_text_length?: number;
  /** Character length of the content/context provided with the request */
  content_length?: number;
  /** The session ID where the request was made */
  session_id?: string;
};

/** Optional detailed props for Ask Heidi compliance tracking functions (source/status set automatically) */
export type NHSAskHeidiComplianceDetailedProps = Omit<
  NHSAskHeidiComplianceProps,
  'source' | 'status'
>;
